// extracted by mini-css-extract-plugin
export default {"tableContainer":"ProductBaseSupplierTable_tableContainer__wKh-I","productName":"ProductBaseSupplierTable_productName__xnl7W"};